import React, {createRef} from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

import ComponentWithClassMethods from "../../component-with-class-methods"
import {BUS_VSCROLL_DRAGGING_IN_PROGRESS} from "../custom-v-scroll/v-scroll";

export default class HScroll extends ComponentWithClassMethods {

    public bindedHandleMouseMove    : any
    public bindedHandleMouseUp      : any

    public displayName              : string    = 'HScroll'
    public isDragging               : boolean   = false
    public mouseDown                : boolean   = false
    public lastMousePosition        : any       = {x:0,y:0}

    public initialScrollLeftDone    : boolean   = false
    public childrenContainer        : any
    public hDrag                    : any
    public hTrackNode               : any

    public vScrollDraggingInProgress: boolean   = false

    private scrollSequence          : any
    private silentScroll            : boolean   = false
    private stop?                   : {():void}
    private lastScrollLeft          : number    = 0

    private childrenContainerRef    : any       = createRef()
    private hDragRef                : any       = createRef()
    private hTrackRef               : any       = createRef()

    private calculateTimeout?       : NodeJS.Timeout

    static propTypes = {
        containerClass          : PropTypes.string,

        scrollLeft              : PropTypes.number,
        scrollVisibility        : PropTypes.oneOf(['show', 'hover', 'auto']),
        scrollOverContent       : PropTypes.bool,

        hideVerticalScroll      : PropTypes.bool,

        minDragWidth            : PropTypes.number,
        trackPadding            : PropTypes.number,

        initialCalculateDelay   : PropTypes.number,

        dragMoveEnabled         : PropTypes.bool,

        containerStyle          : PropTypes.object,
        style                   : PropTypes.object,

        onContainerMouseDown    : PropTypes.func,
        onEndPreReach           : PropTypes.func,
        onScroll                : PropTypes.func,
        onUserScroll            : PropTypes.func
    }

    static defaultProps = {
        scrollVisibility        : 'hover',
        scrollOverContent       : false,
        minDragWidth            : 100, //px
        trackPadding            : 0,
        initialCalculateDelay   : 0,

        dragMoveEnabled         : false
    }

    constructor(props:any) {
        super(props)

        this.state = {
            noScroll: true
        }
    }

    componentDidMount() {
        this.bindedHandleMouseMove  = this.handleMouseMove
        this.bindedHandleMouseUp    = this.handleMouseUp

        document.addEventListener("mousemove", this.bindedHandleMouseMove, {capture: true})
        document.addEventListener("mouseup", this.bindedHandleMouseUp, {capture: true})

        gd.bus.subscribe(BUS_VSCROLL_DRAGGING_IN_PROGRESS,this,this.onVScrollDraggingInProgress)

        this.childrenContainer      = ReactDOM.findDOMNode(this.childrenContainerRef.current)
        this.hDrag                  = ReactDOM.findDOMNode(this.hDragRef.current)
        this.hTrackNode             = ReactDOM.findDOMNode(this.hTrackRef.current)

        // timeout required to fix initial scroll track size
        this.calculateTimeout = setTimeout(()=>{
            this.calculateScroll(this.props.scrollLeft)
        }, this.props.initialCalculateDelay)
    }

    componentDidUpdate() {
        this.calculateScroll()
    }

    componentWillUnmount() {
        clearTimeout(this.calculateTimeout)

        document.removeEventListener("mousemove", this.bindedHandleMouseMove, {capture: true})
        document.removeEventListener("mouseup", this.bindedHandleMouseUp, {capture: true})

        gd.bus.unsubscribe(this)
    }

    onVScrollDraggingInProgress = (value: boolean) => {
        this.vScrollDraggingInProgress = value
        if (value) this.onContainerMouseUp()
    }

    getChildrenContainerDOMNode = () => {
        return this.childrenContainer
    }

    setScrollLeft = (value: number, isCentered: boolean, duration = 500) => {
        const scrollLeft    = isCentered ? value - this.childrenContainer.offsetWidth/2 : value
        if (this.scrollSequence) this.scrollSequence.stop()
        this.scrollSequence = this.smoothScrollLeftTo(this.childrenContainer, scrollLeft, duration)
    }

    setScrollTop = (value: number, options: any) => {
        this.childrenContainer.scrollTop = value
        this.silentScroll = options && options.silent ? options.silent : false
    }

    onChildScroll = () => {
        this.calculateScroll()
        if (this.props.onScroll) {
            if (this.silentScroll) this.silentScroll = false
            else this.props.onScroll()
        }
    }

    calculateScroll = (initScrollLeft?: number, forceScroll?: boolean) => {
        if ((!this.initialScrollLeftDone || forceScroll) && initScrollLeft) {
            this.initialScrollLeftDone          = true
            this.childrenContainer.scrollLeft   = initScrollLeft
        }

        const calculatedOffsetWidth = this.props.hideVerticalScroll ? this.childrenContainer.offsetWidth - gd.layout.scrollWidth: this.childrenContainer.offsetWidth

        let percentVisible = (calculatedOffsetWidth / this.childrenContainer.scrollWidth) * 100
        const percentScrolled = (this.childrenContainer.scrollLeft / (this.childrenContainer.scrollWidth - calculatedOffsetWidth)) * 100

        if (percentScrolled >= 98) {
            if (this.props.onEndPreReach) this.props.onEndPreReach()
        }

        const dragWidth = percentVisible/100 * calculatedOffsetWidth
        let dragLeftPosition = calculatedOffsetWidth * this.childrenContainer.scrollLeft / this.childrenContainer.scrollWidth

        if (dragWidth < this.props.minDragWidth) {
            percentVisible = (this.props.minDragWidth / calculatedOffsetWidth) * 100
            dragLeftPosition = Math.floor((calculatedOffsetWidth - this.props.minDragWidth + dragWidth) * this.childrenContainer.scrollLeft / this.childrenContainer.scrollWidth)
        }

        if (dragLeftPosition >= 0) {
            // this.hDrag.style["left"]        = dragLeftPosition + 'px'
            this.hDrag.style["transform"]   = 'translate3d('+dragLeftPosition+'px, 0px, 0px)'
            this.hDrag.style["width"]       = this.props.trackPadding !== 0 ? 'calc(' + percentVisible + '% - ' + (this.props.trackPadding + 1) + 'px)' : percentVisible + '%'
        }

        const noScroll = percentVisible === 100
        if(this.state.noScroll !== noScroll) {
            this.setState({
                noScroll: noScroll
            })
        }
    }

    smoothScrollLeftTo = (element: any, target: any, duration: number) => {
        let timer:any
        target      = Math.round(target)
        duration    = Math.round(duration)
        if (duration < 0) {
            return console.log("smoothScrollLeftTo: bad duration")
        }
        if (duration === 0) {
            element.scrollLeft = target
            return
        }

        const start_time    = Date.now()
        const end_time      = start_time + duration

        const start_left    = element.scrollLeft
        const distance      = target - start_left

        // based on http://en.wikipedia.org/wiki/Smoothstep
        const smooth_step = (start:number, end:number, point:number)=>{
            if(point <= start) { return 0 }
            if(point >= end) { return 1 }
            const x = (point - start) / (end - start) // interpolation
            return x*x*(3 - 2*x)
            //return x
        };

        // This is to keep track of where the element's scrollTop is
        // supposed to be, based on what we're doing
        let previous_left = element.scrollLeft

        // This is like a think function from a game loop
        const scroll_frame = ()=>{

            /*//check if interrupted
             if(element.scrollLeft != previous_left)  return;*/

            // set the scrollLeft for this frame
            const now       = Date.now()
            const point     = smooth_step(start_time, end_time, now)
            const frameLeft = Math.round(start_left + (distance * point))
            element.scrollLeft = frameLeft

            this.calculateScroll(frameLeft, true)

            // check if we're done!
            if(now >= end_time) {
                return
            }

            // If we were supposed to scroll but didn't, then we
            // probably hit the limit, so consider it done; not
            // interrupted.
            if(element.scrollLeft === previous_left
                && element.scrollLeft !== frameLeft) {
                return
            }
            previous_left = element.scrollLeft

            // schedule next frame for execution
            timer = setTimeout(scroll_frame, 0)
        };

        this.stop = ()=>{
            if (timer) {
                clearTimeout(timer)
                timer = null
            }
        }

        // boostrap the animation process
        timer = setTimeout(scroll_frame, 0)

        return this
    }

    handleMouseMove = (e:any) => {
        if(this.isDragging){
            e.preventDefault();
            const deltaX = this.lastMousePosition.x - e.clientX

            let dragWidth = this.childrenContainer.offsetWidth / this.childrenContainer.scrollWidth * this.childrenContainer.offsetWidth;
            let newLeft
            if (dragWidth < this.props.minDragWidth) {
                newLeft = this.lastScrollLeft - (deltaX * this.childrenContainer.scrollWidth / (this.childrenContainer.offsetWidth - this.props.minDragWidth + dragWidth))
            } else {
                newLeft = this.lastScrollLeft - (deltaX * this.childrenContainer.scrollWidth / this.childrenContainer.offsetWidth )
            }

            this.childrenContainer.scrollLeft = newLeft > 0 ? newLeft : 0

            this.calculateScroll()
        } else if (this.mouseDown) {
            const newMousePosition = {x: e.clientX, y: e.clientY}

            this.lastScrollLeft += this.lastMousePosition.x - newMousePosition.x
            this.lastScrollLeft = this.lastScrollLeft > 0 ? this.lastScrollLeft : 0

            this.lastMousePosition = _.assign({}, newMousePosition)

            this.childrenContainer.scrollLeft = this.lastScrollLeft

            this.calculateScroll()
        }
    }

    handleMouseDown = (e:any) => {
        const childrenContainer:any = ReactDOM.findDOMNode(this.childrenContainerRef.current)

        this.isDragging = true

        this.addClass('is-dragging', this.hTrackNode)

        this.lastMousePosition  = {x: e.clientX, y: e.clientY}
        this.lastScrollLeft     = childrenContainer?.scrollLeft
    }

    handleMouseUp = (e:any) => {
        if (this.isDragging) {
            this.isDragging = false
            this.removeClass('is-dragging', this.hTrackNode)

            this.onUserScroll()
        }
    }

    onUserScroll = () => {
        if (this.props.onUserScroll) this.props.onUserScroll()
    }

    onContainerMouseDown = (e:any) => {
        if (!this.props.dragMoveEnabled || this.vScrollDraggingInProgress) return

        const childrenContainer: any= ReactDOM.findDOMNode(this.childrenContainerRef.current)

        const proceed = () => {
            this.mouseDown          = true
            this.lastMousePosition  = {x: e.clientX, y: e.clientY}
            this.lastScrollLeft     = childrenContainer.scrollLeft
        }

        if (this.props.onContainerMouseDown) {
            this.props.onContainerMouseDown(e, proceed)
        } else {
            proceed()
        }
    }

    onContainerMouseUp = (e?:any) => {
        if (this.mouseDown) {
            this.mouseDown = false
            this.onUserScroll()
        }
    }

    onContainerMouseLeave = (e?:any) => {
        if (this.mouseDown) {
            this.mouseDown = false
            this.onUserScroll()
        }
    }

    render() {
        const scrollClasses = Classes('h-scroll', this.props.className, {
            "h-no-scroll"               : this.state.noScroll,
            "h-scroll-show"             : this.props.scrollVisibility === 'show',
            "h-scroll-on-hover"         : this.props.scrollVisibility === 'hover',
            "h-scroll-auto"             : this.props.scrollVisibility === 'auto',
            "h-scroll-no-webkit-scroll" : gd.layout.scrollWidth === 0,
            "h-scroll-over-content"     : this.props.scrollOverContent,
            "hide-vertical-scroll"      : this.props.hideVerticalScroll
        });
        const childrenContainerClasses = Classes('h-children-container', this.props.containerClass, {'osx-hidden-scroll': !gd.layout.scrollWidth})

        const childrenContainerStyles = _.assign({
            height: "calc(100% + "+gd.layout.scrollWidth+"px)"
        }, this.props.containerStyle)

        if (this.props.hideVerticalScroll) {
            childrenContainerStyles.width = "calc(100% + "+gd.layout.scrollWidth+"px)"
        }

        return (
            <div className      = {scrollClasses}
                 style          = {this.props.style}
                 onMouseDown    = {this.onContainerMouseDown}
                 onMouseUp      = {this.onContainerMouseUp}
                 onMouseLeave   = {this.onContainerMouseLeave}>

                <div ref        = {this.hTrackRef}
                     className  = "h-track">
                    <div ref            = {this.hDragRef}
                         className      = "h-drag"
                         onMouseDown    = {this.handleMouseDown}/>
                </div>

                <div ref        = {this.childrenContainerRef}
                     className  = {childrenContainerClasses}
                     onScroll   = {this.onChildScroll}
                     style      = {childrenContainerStyles}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}